import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import FileUpload from '@/Controls/FileUpload';
import FileUploadViewModel from '@/ViewModels/Controls/FileUploadViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class FileUploadFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private FileUpload = ComponentManager.getControl<typeof FileUpload>('FileUpload');

    /**
     * @override
     */
    public viewModel: FileUploadViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: FileUpload;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel;

        this.control = new this.FileUpload(this.viewModel);

        var tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('FileUpload', FileUploadFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');